export type SourcingCebiaReportStatus = 'accepted' | 'pending' | 'completed' | 'error' | 'canceled';

export type SourcingCebiaCompletedReport = {
  id: string;
  vin: string;
  reportUrl: string | null;
  reportUrlValidTo: string | null;
  pdfUrl: string | null;
  createdAt: string;
};

export type SourcingCebiaReport = {
  id: string;
  status: SourcingCebiaReportStatus;
  pdfUrl: string | null;
  createdAt: string;
  createdBy: string;
  requestId: string | null;
  latestCompleted: SourcingCebiaCompletedReport | null;
  canRegenerate?: boolean;
};

export type SourcingCebiaReportSummary = Pick<SourcingCebiaReport, 'id' | 'status'> & {
  latestCompletedReportId: string | null;
  latestCompletedVin: string | null;
  latestCompletedReportUrlValidTo: string | null;
  canRegenerate?: boolean;
};

export type GetSourcingCebiaReportApiArg = {externalId: string};
export type GetSourcingCebiaReportApiResponse = SourcingCebiaReport;

export type GetSourcingCebiaReportStatusesApiArg = {externalIds: string[]};
export type GetSourcingCebiaReportStatusesApiResponse = {
  reports: Partial<Record<string, SourcingCebiaReportSummary>>;
};

export type CreateSourcingCebiaReportApiArg = {externalId: string};
export type CreateSourcingCebiaReportApiResponse = SourcingCebiaReport;

export type RegenerateSourcingCebiaReportApiArg = {externalId: string; requestId: string};
export type RegenerateSourcingCebiaReportApiResponse = SourcingCebiaReport;
